"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCustom = exports.initialCondition = exports["default"] = exports.SUM = exports.IF_THEN = exports.EQUATION = exports.AVERAGE = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdFormik = require("cccisd-formik");
var _Conditions = _interopRequireDefault(require("./IfThen/Conditions"));
var _Equation = _interopRequireDefault(require("./Equation"));
var _validator = _interopRequireDefault(require("./Equation/validator"));
var _Variables = _interopRequireDefault(require("./Aggregate/Variables"));
var _VariablesCondition = _interopRequireDefault(require("./Aggregate/VariablesCondition"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var AVERAGE = exports.AVERAGE = 'Cccisd\\Metrics\\Formulae\\Average';
var SUM = exports.SUM = 'Cccisd\\Metrics\\Formulae\\Sum';
var EQUATION = exports.EQUATION = 'Cccisd\\Metrics\\Formulae\\Equation';
var IF_THEN = exports.IF_THEN = 'Cccisd\\Metrics\\Formulae\\IfThen';
var isCustom = exports.isCustom = function isCustom(type) {
  return ![SUM, AVERAGE, EQUATION, IF_THEN].includes(type);
};
var initialCondition = exports.initialCondition = {
  aggregation: 'all',
  conditions: [{
    id: 1,
    dataConnector: null,
    operator: '0',
    value: ''
  }]
};
var types = [{
  value: AVERAGE,
  label: 'Average'
}, {
  value: SUM,
  label: 'Sum'
}, {
  value: EQUATION,
  label: 'Equation'
}, {
  value: IF_THEN,
  label: 'If Then'
}];
var Component = function Component(props) {
  var updatingVariableId = props.updatingVariableId,
    isUpdating = props.isUpdating,
    initialValues = props.initialValues,
    closeModal = props.closeModal;
  var validate = function validate(values) {
    var errors = {};
    if (!values.reportHeader) {
      errors.reportHeader = 'Variable Name is required';
    }
    if (!values.label) {
      errors.label = 'Label is required';
    }
    if (values.type === AVERAGE || values.type === SUM) {
      if (values.variables.length < 1) {
        errors.variables = 'At least one variable must be selected';
      }
      if (values.calculateCondition === 'minimum' && values.minimumAnswers < 1) {
        errors.calculateCondition = 'Number of required variables must be greater than 0';
      }
      if (values.calculateCondition === 'minimum' && values.variables.length > 0 && values.minimumAnswers > values.variables.length) {
        errors.calculateCondition = 'Number of required variables must be less than or equal to number of selected variables';
      }
      if (typeof values.minimum === 'number' && typeof values.maximum === 'number' && values.minimum > values.maximum) {
        errors.minimum = 'The min should not be more than max';
      }
    }
    if (values.type === EQUATION) {
      var equationError = (0, _validator["default"])(values);
      if (equationError) {
        errors.equation = equationError;
      }
    }
    if (values.type === IF_THEN) {
      if (!values.ifThen.otherwise) {
        errors['ifThen.otherwise'] = 'Otherwise is required';
      }
      values.ifThen.conditions.forEach(function (rule, index) {
        if (!rule.value) {
          errors["ifThen.conditions.".concat(index, ".value")] = 'Value is required';
        } else if (!rule.condition) {
          errors["ifThen.conditions.".concat(index, ".value")] = 'Condition is required';
        }
      });
    }
    return errors;
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(values) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return props.onSubmit(values);
          case 1:
            closeModal && closeModal();
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var typeOptions = types;
  var isCustomFormula = 'type' in initialValues && isCustom(initialValues.type);
  if (isUpdating && isCustomFormula) {
    var label = initialValues.type ? initialValues.type.split('\\').pop() : '';
    typeOptions = [{
      value: initialValues.type,
      label: label
    }];
  }
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    onSubmit: onSubmit,
    validate: validate,
    initialValues: _objectSpread({
      variables: [],
      type: types[0].value,
      calculateCondition: 'all',
      minimumAnswers: 1,
      ifThen: {
        conditions: [{
          key: 1,
          condition: initialCondition
        }],
        otherwise: '',
        nextKey: 2
      }
    }, initialValues),
    render: function render(_ref2) {
      var errors = _ref2.errors,
        handleSubmit = _ref2.handleSubmit,
        isSubmitting = _ref2.isSubmitting,
        values = _ref2.values;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "reportHeader",
        component: _cccisdFormik.CccisdInput,
        label: "Variable Name",
        disabled: isUpdating
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-6"
      }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "label",
        component: _cccisdFormik.CccisdInput,
        label: "Label",
        disabled: isUpdating
      }))), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "type",
        component: _cccisdFormik.CccisdSelect,
        label: "Calculation",
        options: typeOptions,
        style: {
          width: 'auto'
        },
        disabled: isUpdating
      }), (values.type === AVERAGE || values.type === SUM) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Variables["default"], {
        updatingVariableId: updatingVariableId
      }), /*#__PURE__*/_react["default"].createElement(_VariablesCondition["default"], {
        errors: errors
      })), values.type === EQUATION && /*#__PURE__*/_react["default"].createElement(_Equation["default"], {
        updatingVariableId: updatingVariableId,
        values: values
      }), values.type === IF_THEN && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
        name: "ifThen",
        render: function render(_ref3) {
          var field = _ref3.field,
            form = _ref3.form;
          return /*#__PURE__*/_react["default"].createElement(_Conditions["default"], {
            field: field,
            form: form
          });
        }
      }), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
        className: "btn btn-primary btn-sm",
        isLoading: isSubmitting,
        onClick: handleSubmit,
        title: isUpdating ? 'Update formula' : 'Add formula'
      }));
    }
  });
};
Component.propTypes = {
  updatingVariableId: _propTypes["default"].number,
  isUpdating: _propTypes["default"].bool,
  onSubmit: _propTypes["default"].func.isRequired,
  initialValues: _propTypes["default"].object,
  closeModal: _propTypes["default"].func
};
Component.defaultProps = {
  initialValues: {},
  updatingVariableId: 0
};
var _default = exports["default"] = Component;